'use strict';

/**
 * hover
 */
export const hover = (() => {
    const $hover = $('.js-hover');

    /**
     * init
     */
    const init = () => {
        $hover.each((index, element) => {
            const $this = $(element);

            $this.on('mouseover touchstart', event => {
                on($this);
            });

            $this.on('mouseout touchend', event => {
                off($this);
            });
        });
    };

    /**
     * on
     */
    const on = $element => {
        $element.addClass('is-on');
    };

    /**
     * off
     */
    const off = $element => {
        $element.removeClass('is-on');
    };

    // public
    return {
        init: init
    };
})();
